const debounce = (callback, wait = 0) => {
  if (typeof callback !== 'function') {
    throw new TypeError('Expected a function');
  }

  let timeoutId = null;
  let lastArgs;
  let lastContext;
  let result;

  const invoke = () => {
    timeoutId = null;
    const args = lastArgs;
    const context = lastContext;
    lastArgs = undefined;
    lastContext = undefined;
    result = callback.apply(context, args);
    return result;
  };

  function debounced(...args) {
    lastArgs = args;
    lastContext = this;

    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(invoke, wait);
    return result;
  }

  debounced.cancel = () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = null;
    lastArgs = undefined;
    lastContext = undefined;
  };

  debounced.flush = () => {
    if (timeoutId === null) {
      return result;
    }
    clearTimeout(timeoutId);
    return invoke();
  };

  return debounced;
};

export default debounce;
